export { formatPrice } from '../../GuestOrder/utils/formatters'

export const formatDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString + 'T00:00:00')
  return date.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export const generateTimeOptions = () => {
  const options = []
  // Generate time slots from 08:00 to 22:00 in 30-minute increments
  for (let hour = 8; hour <= 22; hour++) {
    for (let min = 0; min < 60; min += 30) {
      const h = hour.toString().padStart(2, '0')
      const m = min.toString().padStart(2, '0')
      options.push(`${h}:${m}`)
    }
  }
  return options
}
